import { Component, OnInit } from '@angular/core';
import {PartnerCounterService} from '../../services/partner-counter.service';
import {PartnerInvoice, PartnerInvoiceLineItem} from '../../../dto/partnerCounter';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastService} from 'angular-toastify';
import {FileHelper} from '../../../helpers/file-helper';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-partner-counter-invoice-detail',
  templateUrl: './partner-counter-invoice-detail.component.html',
  styleUrls: ['./partner-counter-invoice-detail.component.css']
})
export class PartnerCounterInvoiceDetailComponent implements OnInit {

  constructor(
    private partnerCounterService: PartnerCounterService,
    private route: ActivatedRoute,
    private _toastService: ToastService,
    private router: Router,
    private dialog: MatDialog,
  ) { }

  invoiceId: number;
  companyId: number;
  invoice: PartnerInvoice|null;
  isLoading = false;
  lineItemCodes: string[];

  displayedColumns: string[] = ['del', 'description', 'numberOfItems', 'netAmountPerItem', 'currency', 'netTotal'];
  invoiceLineItems: PartnerInvoiceLineItem[] = [];
  commissionLineItems: PartnerInvoiceLineItem[] = [];


  ngOnInit(): void {

    this.invoiceId = parseInt(this.route.snapshot.paramMap.get('invoiceId'));
    this.companyId = parseInt(this.route.snapshot.paramMap.get('companyId'));

    this.loadInvoice();

  }

  loadInvoice() {
    this.isLoading = true;
    this.partnerCounterService.getLineItemCodes().subscribe(data => {
      this.lineItemCodes = data;
      this.partnerCounterService.getInvoice(this.companyId, this.invoiceId).subscribe(invoice => {
        this.invoice = invoice;

        const inv: PartnerInvoiceLineItem[] = [];
        const com: PartnerInvoiceLineItem[] = [];

        this.invoice.lineItems.forEach((item) => {

          if ( item.type === 1 ) {
inv.push(item);
} else if ( item.type === 2 ) {
com.push(item);
}
        });

        this.invoiceLineItems = inv;
        this.commissionLineItems = com;

        this.isLoading = false;
      });
    });


  }

  deleteItemFromInvoice(item: PartnerInvoiceLineItem) {
    const index = this.invoice.lineItems.indexOf(item, 0);
    if (index > -1) {
      this.invoice.lineItems.splice(index, 1);
      this.invoice.lineItems = [...this.invoice.lineItems];

      this._toastService.info('Item \''+item.description+'\' was removed');

    }

  }

  goBack() {

  }

  addItemToInvoice() {
    const newItem = new PartnerInvoiceLineItem();

    newItem.code = '';
    newItem.netAmountPerItem = 0;
    newItem.numberOfItems = 1;
    newItem.description = '(enter description here)';
    newItem.currencyCode = 978;

    this.invoice.lineItems.push(newItem);

    this.invoice.lineItems = [...this.invoice.lineItems];

  }

  updateInvoice() {

    this.isLoading = true;

    this.invoice.lineItems = [];
    this.invoice.lineItems = [...this.invoiceLineItems, ...this.commissionLineItems];

    this.partnerCounterService.updateInvoice(this.companyId, this.invoice).subscribe(data => {
      this._toastService.success('invoice updated');
      this.invoice = data;
      this.isLoading = false;

    });

  }

  deleteInvoice() {

    this.dialog.open(ConfirmDialogComponent, { data: { title: 'Delete invoice', text: 'Are you sure you want to delete this invoice?' } })
      .afterClosed()
      .subscribe(result => {
        if (result == 'ok') {
          this.partnerCounterService.deleteInvoice(this.companyId, this.invoiceId).subscribe(data => {
            this._toastService.warn('invoice deleted');

            this.router.navigate(['administration', 'partner-counter'], );

          });
        }
      });

  }

  downloadInvoicePdf() {

    this.isLoading = true;

    this.invoice.lineItems = [];
    this.invoice.lineItems = [...this.invoiceLineItems, ...this.commissionLineItems];

    this.partnerCounterService.updateInvoice(this.companyId, this.invoice).subscribe(data => {
      this.invoice = data;

      this.partnerCounterService.downloadInvoicePdf( this.invoiceId, this.companyId ).subscribe(
        result => {
          this.isLoading = false;
          FileHelper.saveFile( result );
        },
        err =>
          this._toastService.error(err.error.message || err.message || err.error || err)
      );



    });


  }
}
